/* eslint-disable no-console */
/**
	* Global message handler to catch and handle unknown message types
	* This prevents console errors from third-party browser extensions or external scripts
*/

const KNOWN_MESSAGE_TYPES = [
	'error-notifications',
	'info-notifications',
	'notifications',
	'success-notifications',
]

const handleUnknownMessage = (event: MessageEvent<WindowMessage>) => {
	const { type } = event.data || {}

	const ignoredMessages = [
		'hide-notification',
		'show-notification',
	]

	if (ignoredMessages.includes(type)) {
		return
	}

	if (process.env.NODE_ENV === 'development') {
		console.debug('Unknown message received:', event.data)
	}
}

export const setupGlobalMessageHandler = () => {
	if (typeof window !== 'undefined') {
		window.addEventListener('message', (event: MessageEvent) => {
			try {
				const messageData = event.data

				if (!messageData || typeof messageData !== 'object') {
					return
				}

				const { type } = messageData

				if (KNOWN_MESSAGE_TYPES.includes(type as KnownMessageType)) {
					return
				}

				handleUnknownMessage(event)
			} catch (error) {
				if (process.env.NODE_ENV === 'development') {
					console.debug('Error handling message:', error)
				}
			}
		})
	}
}

export const removeGlobalMessageHandler = () => {
	if (typeof window !== 'undefined') {
		window.removeEventListener('message', handleUnknownMessage)
	}
}

interface WindowMessage {
	data?: any
	type: string
}

type KnownMessageType
	= 'error-notifications'
	| 'info-notifications'
	| 'notifications'
	| 'success-notifications'
/* eslint-enable */
